import EventEdit from '@/components/Event/EventEdit';

export default function Route() {
  return <EventEdit />;
}
